export default "__VITE_ASSET__BXOyIrtQ__"